module.exports = __webpack_public_path__ + "media/images/smart_phone/aichi-f26140f599d03fed95a31b8e8b95fab8.gif";